import { ConnectIntegrationForm } from "../connect-integration-form"
import { use_connect_redirect_to } from "../use_connect_redirect_to"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ConnectWakefernPage(props: any = {}) {
  const redirectTo = use_connect_redirect_to(props.redirectTo)

  return (
    <ConnectIntegrationForm
      integrationName="wakefern"
      redirectTo={redirectTo}
      logoSrc="/img/integration/wakefern.png"
      logoAlt="Wakefern"
      description="Enter your Wakefern credentials to sync your deduction data."
    />
  )
}
